import { useEffect, useRef } from "react";
import { AnalyticsSource, logUpsellSurfaceShown } from "../models/analytics";

type CheckoutTier = "supporter" | "pro";

// Fires upsell_surface_shown exactly once per mount, the first time `shouldFire`
// is true. Subsequent flips of `shouldFire` (e.g. tier resolving from loading
// to free, then user upgrading mid-session) do not re-fire — one impression per
// surface mount.
export function useUpsellImpression(
  surface: AnalyticsSource,
  tier: CheckoutTier,
  shouldFire: boolean,
): void {
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) return;
    if (!shouldFire) return;
    fired.current = true;
    logUpsellSurfaceShown(surface, tier);
  }, [shouldFire, surface, tier]);
}
